<template>
  <sf-icon-button :size="32" :icon="mdiFileTree" :aria-label="$t('showCategories')" />
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import { mdiFileTree } from '@mdi/js'
</script>
